module.exports = __webpack_public_path__ + "img/banner.e44ddc43.png";